import { useState } from 'react'
import Box from '@mui/material/Box'
import Lightbox from "yet-another-react-lightbox"
import Captions from "yet-another-react-lightbox/plugins/captions"
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen"
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails"
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import Download from "yet-another-react-lightbox/plugins/download"
import "yet-another-react-lightbox/styles.css"
import "yet-another-react-lightbox/plugins/captions.css"
import "yet-another-react-lightbox/plugins/thumbnails.css"

import type { UploadedDocument } from '@/types'

const IMAGE_EXTENSIONS = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'webp',
    'bmp',
    'tiff',
]

export default function DocumentsPreview({
    attachments,
}: {
    attachments: Array<UploadedDocument>,
}) {

    const [open, setOpen] = useState<number | null>(null)

    const { images, pdfs } = attachments.reduce(
        (acc, attachment) => {
            const extension = attachment.filename.split('.').pop()?.toLowerCase()

            if (extension && IMAGE_EXTENSIONS.includes(extension)) {
                acc.images.push(attachment)
            } else if (extension === 'pdf') {
                acc.pdfs.push(attachment)
            }

            return acc
        },
        {
            images: [] as UploadedDocument[],
            pdfs: [] as UploadedDocument[],
        }
    )

    return (
        <Box flexGrow={1}>
            {images.map((image, index) => (
                <Box
                    key={image.id}
                    sx={{
                        cursor: 'pointer',
                    }}
                    onClick={() => setOpen(index)}
                >
                    <img
                        src={image.url}
                        alt={image.filename}
                        style={{
                            width: '100%',
                            height: 'auto',
                        }}
                        loading='lazy'
                    />
                </Box>
            ))}
            {pdfs.map((pdf) => (
                <embed
                    key={pdf.id}
                    src={pdf.url}
                    type="application/pdf"
                    width="100%"
                    style={{ height: '100%', minHeight: '50vh' }}
                />
            ))}
            <Lightbox
                open={open != null}
                close={() => setOpen(null)}
                slides={images.map(image => ({ src: image.url, alt: image.filename, title: image.filename }))}
                index={open ?? undefined}
                plugins={[Captions, Download, Fullscreen, Thumbnails, Zoom]}
                carousel={{ finite: true }}
            />
        </Box>
    )
}
